import * as React from 'react'
import { cn } from '@/lib/cn'

interface SectionEyebrowProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
}

export function SectionEyebrow({ className, children, ...props }: SectionEyebrowProps) {
  return (
    <span
      className={cn('text-xs font-semibold uppercase tracking-widest text-text-muted', className)}
      {...props}
    >
      {children}
    </span>
  )
}
